import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpAuctionDetails
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Details for an auction.
     *
     * @param {String} header Not an Angular expression. A headline shown above the details. Defaults to "Product".
     * @param {Object} auction An `AuctionDto` JSON representation. The `networkPoint` node will suffice,
     *  if `productOnly` is set to `true`.
     * @param {Object} config `AuctionConfigDto`
     * @param {boolean} productOnly If `true`, only details regarding the product will be shown.
     * @param {boolean} lazyLoad If `true`, the backend will be requested for the auction when the directive
     *  initializes.
     * @param {Number} auctionId Used for the lazy loading, to fetch the auction by this id.
     * @param {Object} maxQuantity The max quantity used for volume-based regulated tariffs.
     * @param {Object} minQuantity The min quantity used for volume-based regulated tariffs.
     * @param {boolean} expandFees If `true`, the volume base tariff fees will be initially expanded and displayed to the user
     * @param {Object} undiscounted Controls if regulated tariff and starting price needs to be doubled for auctions at storage points.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpAuctionDetails', pkpAuctionDetails);

    function pkpAuctionDetails(
        $q,
        $filter,
        DATES,
        auctionResource,
        auctionsOverviewService
    ) {
        return {
            restrict: 'E',
            scope: {
                header: '@?',
                auction: '=',
                config: '=?',
                productOnly: '=?',
                excludeRuntime: '=?',
                excludeId:
                    '=?' /* TODO Maybe this can just always be included? Ask Andreas. */,
                includeMarketArea:
                    '=?' /* TODO Maybe this can just always be included? Ask Andreas. */,
                hideLogos: '=?',
                hideNotes: '=?',
                lazyLoad: '=?',
                auctionId: '=?',
                maxQuantity: '=?',
                minQuantity: '=?',
                expandFees: '@?',
                undiscounted: '=?'
            },
            template: require('app/_directives/pkp-auction-details.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.DATES = DATES;
            scope.uiLoadingAuction = false;
            scope.uiLoadingErrorAuction = false;
            scope.tsoRange = [];
            scope.hasFeesAttached = false;
            scope.getCapacityCategory = getCapacityCategory;

            scope.expandFees = true;

            if (scope.lazyLoad === true) {
                scope.uiLoadingAuction = true;
                var param = { auctionId: scope.auctionId };

                var auctionPromise = auctionResource.get(param, function (res) {
                    scope.auction = res;
                    scope.uiLoadingErrorAuction = false;
                    scope.hasFeesAttached = hasFeesAttached();
                    setTsoRange();
                }).$promise;

                var configPromise = auctionResource.config(
                    param,
                    function (res) {
                        scope.config = res;
                    }
                ).$promise;

                $q.all([auctionPromise, configPromise])
                    .then(function () {
                        if (
                            angular.isDefined(scope.config.maximumOrderQuantity)
                        ) {
                            scope.maxBid =
                                auctionsOverviewService.calcMaxLongTermBid(
                                    scope.auction.marketable,
                                    scope.config.maximumOrderQuantity,
                                    scope.auction.auctionWindow,
                                    scope.auction.windows,
                                    true
                                );
                        }
                        scope.uiLoadingErrorAuction = false;
                    })
                    .catch(function () {
                        scope.uiLoadingErrorAuction = true;
                    })
                    .finally(function () {
                        scope.uiLoadingAuction = false;
                    });
            } else {
                if (
                    !!scope.config &&
                    angular.isDefined(scope.config.maximumOrderQuantity)
                ) {
                    scope.maxBid = auctionsOverviewService.calcMaxLongTermBid(
                        scope.auction.marketable,
                        scope.config.maximumOrderQuantity,
                        scope.auction.auctionWindow,
                        scope.auction.windows,
                        true
                    );
                }
                scope.lazyLoad = false;
                scope.hasFeesAttached = hasFeesAttached();
                setTsoRange();
            }

            if (scope.productOnly !== true) {
                scope.productOnly = false;
            }

            if (scope.excludeRuntime !== true) {
                scope.excludeRuntime = false;
            }

            function hasFeesAttached() {
                if (!scope.auction) {
                    return false;
                }

                return auctionsOverviewService.hasFeesAttached(scope.auction);
            }

            function setTsoRange() {
                if (scope.auction.networkPoint.bundled) {
                    scope.tsoRange = ['0', '1'];
                } else {
                    scope.tsoRange = ['0'];
                }
            }

            function getCapacityCategory(tsoNumber) {
                if (scope.auction['capacityCategory' + tsoNumber]) {
                    return scope.auction['capacityCategory' + tsoNumber];
                }
                if (
                    scope.auction.components &&
                    scope.auction.components.length > tsoNumber
                ) {
                    if (scope.auction.components[tsoNumber].capacityCategory) {
                        return scope.auction.components[tsoNumber]
                            .capacityCategory;
                    }
                }
                if (scope.auction.capacityCategory) {
                    return scope.auction.capacityCategory;
                }
                return null;
            }
        }
    }
})();
